
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { FormControl, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { PaidToFacilityFormControls } from '../../models/paid-to-facility.model';

@Component({
    selector: 'app-paid-to-facility-pair',
    imports: [ReactiveFormsModule, MatFormFieldModule, MatInputModule, MatIconModule, MatButtonModule],
    templateUrl: './paid-to-facility-pair.component.html',
    styleUrl: './paid-to-facility-pair.component.scss'
})
export class PaidToFacilityPairComponent {
    @Input({ required: true }) group!: FormGroup<PaidToFacilityFormControls>;
    @Input() showRemove: boolean = false;
    @Output() remove = new EventEmitter<void>();

    get facilityIdControl(): FormControl<string | null> {
        return this.group.controls['paidToFacilityId'];
    }

    get labelControl(): FormControl<string | null> {
        return this.group.controls['label'];
    }
}
